import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconArrow24 } from 'src/assets/icons/24x24/IconArrow24';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles';

export const ArrowIcon = ({ className, direction, ...restProps }) => {
  const styles = useStyles({ direction });
  return (
    <IconArrow24
      className={cx(styles.root, className)}
      {...restProps}
    />
  );
};

ArrowIcon.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(ROTATE_DIRECTION)),
};
ArrowIcon.defaultProps = {
  className: '',
  direction: ROTATE_DIRECTION.right,
};
